import {Injectable} from '@angular/core';
import {StorageService} from './storage.service';

const THEMES = {
    'light': 'light-styles',
    'dark': 'dark-styles'
};

const STORAGE_THEME_KEY = 'theme';

@Injectable()
export class ThemeService {

    constructor(
        private readonly storageService: StorageService,
    ) {
        this.loadTheme(THEMES[this.getCurrentTheme()]);
    }

    changeTheme(themeKey: string): boolean {
        if (!THEMES[themeKey]) {
            return false;
        }

        this.loadTheme(THEMES[themeKey]);
        this.storageService.setItem(STORAGE_THEME_KEY, themeKey);

        return true;
    }

    getCurrentTheme() {
        const savedUserTheme = this.storageService.getItem(STORAGE_THEME_KEY);

        if (savedUserTheme !== null && THEMES[savedUserTheme]) {
            return savedUserTheme;
        } else {
            return 'light';
        }
    }

    private loadTheme(fileName: string) {
        const stylesheets = document.getElementsByTagName('link');

        for (let i = 0; i < stylesheets.length; i++) {
            stylesheets[i].disabled = stylesheets[i].href.indexOf(fileName) === -1;
        }
    }

}
